import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { DataGrid } from '@mui/x-data-grid';
import Swal from 'sweetalert2';
import {Link, useParams} from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function WardChange(props){

  const {ip_id} = useParams();
  const [ipData, setIpData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000));
  const [roomData, setRoomData] = useState([]);
  const [roomNoData, setRoomNoData] = useState([]);
  const [selectedRoomType, setSelectedRoomType] = useState('');
  useEffect(() => {
    fetchData();
  }, []);

  function fetchData() {
    axios.get(baseUrl + "edit-ip-admit/" + ip_id + "/")
      .then(response => {
        setIpData([response.data]);
      })
      .catch(error => {
        console.log(error);
      });
  }
   const handleDateChange = (date) => {
      if (date) {
        const dateString = date.toISOString().slice(0,10);
        const dateObj = new Date(dateString);
        dateObj.setHours(0, 0, 0, 0);
        setSelectedDate(dateObj);
        }
   };

  useEffect(() => {
    fetchRoomData();
  }, []);

  function fetchRoomData() {
    axios.get(baseUrl + "room-type/")
      .then(response => {
        setRoomData(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  }

  useEffect(() => {
   if (selectedRoomType) {
    fetchRoomNoData(selectedRoomType);
   }
  }, [selectedRoomType]);

  const handleRoomTypeChange = (event) => {
    const selectedRoomTypeId = event.target.value;
    setSelectedRoomType(selectedRoomTypeId);
  };

  function fetchRoomNoData(selectedRoomTypeId) {
    axios.get(baseUrl + "room-no/" + selectedRoomTypeId)
      .then(response => {
        setRoomNoData(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  }
  const formSubmit = (e) => {
      e.preventDefault();
          const _formData = new FormData();
          const room_no = document.getElementById("room_no").value;
          const exroom = ipData.map(row => row.room_no.id);
          _formData.append('ip', ip_id);
          _formData.append('croom', exroom);
          _formData.append('change_date', selectedDate.toISOString().slice(0,10));
          _formData.append('addedby', userName);
          _formData.append('status', 1);
          _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);
          axios.post(`${baseUrl}ward-change-create/`, _formData)
            .then(response => {
              if(response.status==200 || response.status==201){
                _formData.append('status',0);
                _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);
                axios.put(`${baseUrl}edit-room-no/${room_no}/`, _formData)
                .then(response2 => {
                  if(response2.status==200 || response2.status==201){
                  _formData.append('status',1);
                  axios.put(`${baseUrl}edit-room-no/${exroom}/`, _formData)
                    .then(response3 => {
                    })
                  }
                const formData = new FormData();
                formData.append('ward_date', selectedDate.toISOString().slice(0,10));
                formData.append('room_no', room_no);
                formData.append('ward_changedby', userName);
                formData.append('ward_status', 1);
                axios.post(`${baseUrl}update-ip-ward/${ip_id}/`, formData)
                .then(response4 => {
                Swal.fire({
                  title: 'Ward Changed Successfully.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                })
                })
                setTimeout(() => {
                  window.location.href = '/ip-pat-view/' + ip_id + '/';
                }, 3000);
              }
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed to add min entry. Please try again later.',
                'error'
              );
            });
  };

    return (
    <section className="container mt-4">
     <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-stethoscope" aria-hidden="true" style={{ color: 'red' }}></i>
      Primary Consultant -  Dr.{ipData.map(row => row.primary_consult.consultant)}
    </h3>
    <div className="table-responsive">
    <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Patient</th>
          <th>IP ID</th>
          <th>Patient ID</th>
          <th>Patient Name</th>
          <th>Gender</th>
          <th>D.O.B/Age</th>
          <th>Mobile</th>
          <th>Regd. On</th>
        </tr>
      </thead>

      <tbody>
        {ipData.map((patientData, index) => (
          <tr >
          <td><img src={patientData.profile_pic} alt="Thumbnail" className="thumbnail" style={{width:120, height:60}}/></td>
            <td>{patientData.ip_id}</td>
            <td>{patientData.pat.pat_id}</td>
            <td>{patientData.pat.patient}</td>
            <td>{patientData.pat.gender}</td>
            <td>{patientData.pat.age}</td>
            <td>{patientData.pat.mobile}</td>
            <td>{formatDateTime(patientData.admit_date)}</td>
          </tr>
        ))}
      </tbody>
    </table>
    </div>
  <div >
  <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-bed-pulse" aria-hidden="true" style={{ color: 'red' }}></i>
      Ward Change - Current Room No - {ipData.map(row => row.room_no.room_no)}
    </h3>
      <form>
      <div className="row">
        <div className="col-md-3">
          <label htmlFor="Advance" className="form-label">Ward Change Date</label>
         <DatePicker selected={selectedDate || new Date()} onChange={handleDateChange} dateFormat="yyyy-MM-dd" />
        </div>
        <div className="col-md-3 mb-3">
            <label htmlFor="room" className="form-label">Room Type</label>
            <select
              className="form-control"
              value={selectedRoomType}
              name="room"
              id="room"
              onChange={handleRoomTypeChange}
            >
              <option>Select Room Type </option>
              {roomData.map((room, index) => (
                <option key={index} value={room.id}>
                  {room.room}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-3 mb-3">
            <label htmlFor="room_no" className="form-label">Room No</label>
            <select className="form-control" name="room_no" id="room_no">
              {roomNoData.map((roomno, index) => (
                <option key={index} value={roomno.id}>
                  {roomno.room_no}
                </option>
              ))}
            </select>
          </div>
       </div>
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='ms-5' >
          <button type="button" onClick={formSubmit} className="btn btn-primary mt-4">Submit</button>
        </div>
      </form>

  </div>
    </section>
    )
}

export default WardChange;